import React from 'react';
import './TermsAndConditions.css';
import btn from '../../assets/images/button.svg';

const termsData = {
  title: 'Terms of Service',
  sections: [
    {
      title: 'SCOPE',
      content: [
        {
          text: 'JioDAM is a web-based portal (‘Portal), provided by Jio Platforms Limited and/or its affiliates (“Company”, “we,” “us” and “our”) located at Office - 101, Saffron Near Centre Point, Panchwati 5 Rasta, Ambavadi Ahmedabad GJ 380006 IN.'
        },
        {
          text: 'The Portal is designed and made available by the Company and/or its affiliates, to provide its users services such as (i) create and manage different roles for the users of the Portal; (ii) create, manage and organize digital assets including but not limited to (a) images, (b) videos, (c) audios, (d) documents etc.; (iii) retrieve and share the digital assets; and (iv) such other services as may be provided by the Company from time to time (collectively known as “Services”) on any browser available on desktop monitors, mobile phones, smart tablets etc. (“Device”).'
        },
        {
          text: 'Your (“you”, “your” or “user”) use of the Portal is subject to these Terms and Conditions (“Terms”)'
        },
        {
          text: 'Your use of the Portal requires that you agree to these Terms and the privacy policy of the Portal. By registering or signing up to the Portal, or otherwise having access to, receiving, and/or using the Portal, you acknowledge to have read, understood and you consent to be governed and bound by these Terms and the privacy policy of the Portal. If you do not understand the Terms or the privacy policy of the Portal, or do not accept any part of them, then you should not use the Portal.'
        },
        {
          text: 'The Terms are an electronic record in terms of the Information Technology Act, 2000 (as amended / re-enacted) (“IT Act") and rules thereunder, and is published in accordance with the provisions of Rule 3 (1) of the of the Information Technology (Intermediary Guidelines and Digital Media Ethics Code) Rules, 2021, which mandates for publishing of rules and regulations, privacy policy and terms of use for access or usage of Portal. This electronic record is generated by a computer system and does not require any physical or digital signatures.'
        }
      ]
    },
    {
      title: 'PRIVACY AND PROTECTION OF PERSONAL INFORMATION',
      content: [
        { text: 'Please refer to the privacy policy of the Portal available here.' }
      ]
    },
    {
      title: 'MODIFICATIONS',
      content: [
        {
          text: 'Modifications of the Terms: The Company reserves the right to change the Terms under which the Services are offered, including but not limited to the charges, if any, associated with the use of the Services. The Terms may be further modified based on changes in the business, legal and regulatory requirements and will be updated online. We will notify you whenever any change to the Terms and Conditions are made. You are encouraged to periodically visit this page to review these Terms and any changes to it.'
        },
        {
          text: 'Modification of Services: The Company reserves the right to add, modify or delete any content or features available in the Services at any time at its sole discretion'
        }
      ]
    },
    {
      title: 'LINKS TO THIRD PARTY SITES AND APPLICATIONS',
      content: [
        {
          text: 'The Portal may contain links to other web sites/applications ("Linked Sites"). The Linked Sites are not under the control of the Company and the Company is not responsible for the contents of any Linked Site, including without limitation any link contained in a Linked Site, or any changes or updates to a Linked Site or any information transmitted on a Linked Site. The inclusion of any link does not imply endorsement by the Company of the site or any association with its operators.'
        },
        {
          text: 'Any dealings with third parties (including advertisers) included within or available via a link from the Portal or participation in promotions, including the delivery of and the payment for goods and services, and any other terms, conditions, warranties or representations associated with such dealings or promotions, are solely between you and the advertiser or other third party. The Company shall not be responsible or liable for any part of any such dealings or promotions.'
        },
        {
          text: 'You acknowledge and agree that the use of any Linked Sites is governed by such third party’s terms of use, license agreement, privacy policy, or other such agreement. THE COMPANY DISCLAIMS ANY AND ALL RESPONSIBILITY FOR ANY DISCLOSURE OF INFORMATION OR ANY OTHER PRACTICES OF ANY THIRD PARTY. THE COMPANY EXPRESSLY DISCLAIMS ANY WARRANTY WITH RESPECT TO YOUR PERSONAL OR OTHER INFORMATION THAT MAY BE COLLECTED, PROCESSED, SHARED OR RETAINED BY ANY THIRD PARTY'
        }
      ]
    },
    {
      title: 'INTELLECTUAL PROPERTY RIGHTS',
      content: [
        {
          text: 'The Company shall own title, interest and rights, including all related intellectual property rights, in/of the Portal including but not limited to object code of the Portal, features of services, which is/are protected by the applicable laws except the content owned by the user. You acknowledge that such ownership shall include all intellectual property rights arising from any suggestions, enhancement requests, recommendations or other information provided by the user, whether in the course of use of the Portal, your Device or otherwise.'
        }
      ]
    },
    {
      title: 'USE LIMITATIONS',
      content: [
        {
          text: 'Services offered by the Portal are intended solely for the purpose of availing Services provided by the Portal. You may not distribute, transmit, display, perform, reproduce, publish, license, create derivative works from, transfer, or sell any information, software, products or Services offered by the Portal.'
        },
        {
          text: "As a condition of your use of the Portal, you warrant to the Company that you will not use the Portal for any purpose that is unlawful or prohibited by these Terms. You may not use the Portal in any manner which could damage, disable, overburden or impair the Services or interfere with any other party's use and enjoyment of the Portal."
        },
        {
          text: 'You are not entitled to use any kind of measures, mechanisms or tools (software or hardware) that could interfere with the functioning of the Portal or any of its Services.'
        },
        {
          text: 'You may not use the Services and/or Portal if (i) you have been convicted of any offence under applicable law; and/or (ii) if you are under the age of 18 years;'
        }
      ]
    },
    {
      title: 'USER NAMES AND PASSWORDS',
      content: [
        {
          text: 'You will be required to sign in using Company’s and/or your employer’s sign-in credentials to access and use the Portal and avail its Services.'
        },
        {
          text: 'You shall provide an accurate and valid email address while signing in as the Company shall verify such an email address prior to granting you access to the Portal.'
        },
        {
          text: 'If at any point during your use of the Portal, the Company discovers (i) such information to be inaccurate and/or (ii) credential abuse, it shall restrict your access to the Portal and/or disable provisioning of Services without any prior intimation.'
        },
        {
          text: 'You are responsible for maintaining the confidentiality of any password you use to access the Portal and you agree not to transfer such passwords or user names or lend or otherwise transfer your use or access to the Portal to any third party. You agree to notify us of any unauthorized use of your passwords or user names or any other breach of security related to your account of which you become aware. You are fully responsible for all use of the Portal and any Services that occur in connection with your user name, except to the extent that any unauthorized use is not caused by any breach of your obligations under these Terms.'
        }
      ]
    },
    {
      title: 'GENERAL',
      content: [
        {
          text: 'By using our Services you hereby agree to ensure that the explicit prohibitions mentioned in section 8.3 are at all times adhered to.'
        },
        {
          text: 'Use Restriction: You must not access the Portal if you are a person who is either barred or otherwise legally prohibited from receiving or using the Service or any Services under the laws of India.',
          sublist: [
            'belongs to another person and to which the user does not have any right;',
            'vacy, insulting or harassing on the basis of gender, racially or ethnically objectionable, relating or encouraging money laundering or gambling, or an online game that causes user harm, or promoting enmity between different groups on the grounds of religion or caste with the intent to incite violence;',
            'is harmful to child;',
            'infringes any patent, trademark, copyright or other proprietary rights;',
            'deceives or misleads the addressee about the origin of the message or knowingly and intentionally communicates any misinformation or information which is patently false and untrue or misleading in nature or, in respect of any business of the Central Government, is identified as fake or false or misleading by such fact check unit of the Central Government as the Ministry may, by notification published in the Official Gazette, specify;',
            'impersonates another person;',
            'threatens the unity, integrity, defence, security or sovereignty of India, friendly relations with foreign States, or public order, or causes incitement to the commission of any cognizable offence, or prevents investigation of any offence, or is insulting other nation;',
            'contains software virus or any other computer code, file or program designed to interrupt, destroy or limit the functionality of any computer resource;',
            'is in the nature of an online game that is not verified as a permissible online game;',
            'is in the nature of advertisement or surrogate advertisement or promotion of an online game that is not a permissible online game, or of any online gaming intermediary offering such an online game;',
            'violates any law for the time being in force;',
            'Provides instructional information about illegal activities such as making and/ or buying illegal weapons, violating someone’s privacy, or providing or creating computer viruses;'
          ]
        },
        {
          text: 'Services may be made available for free of cost or for a specified cost as may be decided by the Company from time to time.'
        },
        {
          text: 'Third-Party Fees: You may incur access or data fees from third parties (such as your internet provider or mobile carrier) in connection with your use of Services and of Portal. You are solely responsible for all such fees.'
        },
        {
          text: 'Updates: You may need to install updates to the Portal or related software that we introduce from time to time to use of the Portal. Services originating from the Portal may communicate with the servers from time to time to check for available updates to the Services and to the functionality of the Portal, such as bug fixes, patches, enhanced functions, missing plug-ins and new versions (collectively, "Updates"). Your use of the Services you have installed requires that you have agreed to receive such automatically requested Updates.'
        },
        {
          text: 'Accuracy of Information: You agree that the information entered by you while profile creation/ updation or using any of Services is true, current, complete and accurate in all respects. The Company is not responsible for any losses arising out of discrepancy in your data. You are solely responsible for maintaining confidentiality and security of your user account and for all activities that occur on or through your user account. The Company is not responsible for any losses arising out of the unauthorized use of your user account.'
        }
      ]
    },
    {
      title: 'LIABILITY DISCLAIMER',
      content: [
        {
          text: 'TO THE MAXIMUM EXTENT PERMITTED BY APPLICABLE LAW, IN NO EVENT SHALL THE COMPANY BE LIABLE TO YOU FOR ANY SPECIAL, INCIDENTAL, INDIRECT, PUNITIVE OR CONSEQUENTIAL DAMAGES WHATSOEVER (INCLUDING, WITHOUT LIMITATION, DAMAGES FOR LOSS OF USE, LOSS OF BUSINESS PROFITS, BUSINESS INTERRUPTION, LOSS OF INFORMATION, OR ANY OTHER PECUNIARY LOSS) ARISING OUT OF THE USE OF, OR INABILITY TO USE OR ACCESS, THE PORTAL OR FOR ANY SECURITY BREACH OR ANY VIRUS, BUG, UNAUTHORIZED INTERVENTION, DEFECT, OR TECHNICAL MALFUNCTIONING OF THE APPLICATION, WHETHER OR NOT FORESEEABLE OR WHETHER OR NOT THE COMPANY HAS BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGES, OR BASED ON ANY THEORY OF LIABILITY, INCLUDING BREACH OF CONTRACT OR WARRANTY, NEGLIGENCE OR OTHER TORTIOUS ACTION, OR ANY OTHER CLAIM ARISING OUT, OF OR IN CONNECTION WITH, YOUR USE OF, OR ACCESS TO, THE PORTAL OR THE CONTENT. FURTHER, THE COMPANY SHALL NOT BE LIABLE TO YOU FOR ANY TEMPORARY DISABLEMENT, PERMANENT DISCONTINUANCE OR MODIFICATION OF THE PORTAL BY THE COMPANY OR FOR ANY CONSEQUENCES RESULTING FROM SUCH ACTIONS.'
        },
        {
          text: 'YOU SHALL BE SOLELY RESPONSIBLE FOR OBTAINING AND MAINTAINING ANY EQUIPMENT AND ANCILLARY SERVICES (INCLUDING THE PAYMENT OF ANY ADDITIONAL FEES THEREFORE) REQUIRED TO CONNECT TO, ACCESS OR OTHERWISE USE THE SERVICES. YOU WILL ALSO BE RESPONSIBLE FOR MAINTAINING THE SECURITY OF THE EQUIPMENT AND FOR ALL USES OF THE EQUIPMENT WITH OR WITHOUT YOUR KNOWLEDGE OR CONSENT.'
        },
        {
          text: 'YOU ARE SOLELY RESPONSIBLE FOR THE CONTENT AND OTHER MATERIALS YOU TRANSMIT THROUGH THE SERVICE OR SHARE WITH OTHER USERS OR RECIPIENTS. YOU WILL NOT TRANSMIT ANY CONTENT THAT YOU DID NOT CREATE OR THAT YOU DO NOT OWN ALL RIGHT, TITLE AND INTEREST IN AND TO, INCLUDING, WITHOUT LIMITATION, ALL COPYRIGHT AND RIGHTS OF PUBLICITY CONTAINED THEREIN.'
        },
        {
          text: 'THE COMPANY AND/OR ITS RESPECTIVE AFFILIATES MAKES NO REPRESENTATIONS ABOUT THE SUITABILITY, RELIABILITY, AVAILABILITY, TIMELINESS AND ACCURACY OF THE INFORMATION, SOFTWARE AND SERVICES AND RELATED CONTENT CONTAINED ON THE PORTAL FOR ANY PURPOSE. ALL SUCH INFORMATION, SOFTWARE AND SERVICES AND RELATED CONTENT ARE PROVIDED "AS IS" WITHOUT WARRANTY OF ANY KIND. THE COMPANY AND/OR ITS RESPECTIVE SUPPLIERS HEREBY DISCLAIMS ALL WARRANTIES AND CONDITIONS WITH REGARD TO THIS INFORMATION, SOFTWARE, AND SERVICES AND RELATED CONTENT, INCLUDING ALL IMPLIED WARRANTIES AND CONDITIONS OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, TITLE AND NON-INFRINGEMENT'
        },
        {
          text: "YOU SPECIFICALLY AGREE THAT THE COMPANY SHALL NOT BE RESPONSIBLE FOR UNAUTHORISED ACCESS TO OR ALTERATION OF YOUR TRANSMISSIONS OR DATA, ANY MATERIAL OR DATA SENT OR RECEIVED OR NOT SENT OR RECEIVED, OR ANY TRANSACTIONS ENTERED INTO THROUGH THE PORTAL. YOU SPECIFICALLY AGREE THAT THE COMPANY IS NOT RESPONSIBLE OR LIABLE FOR ANY THREATENING, DEFAMATORY, OBSCENE, OFFENSIVE OR ILLEGAL SERVICES OR CONDUCT OF ANY OTHER PARTY OR ANY INFRINGEMENT OF ANOTHER'S RIGHTS, INCLUDING INTELLECTUAL PROPERTY RIGHTS. YOU SPECIFICALLY AGREE THAT THE COMPANY IS NOT RESPONSIBLE FOR ANY SERVICES SENT USING AND/OR INCLUDED IN THE PORTAL BY ANY THIRD PARTY"
        },
        {
          text: 'IN NO EVENT SHALL THE COMPANY AND/OR ITS AFFILIATES BE LIABLE FOR ANY DIRECT, INDIRECT, PUNITIVE, INCIDENTAL, SPECIAL, CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER INCLUDING, WITHOUT LIMITATION, DAMAGES FOR OR IN RELATION TO: (A) LOSS OF USE, DATA OR PROFITS ARISING OUT OF OR IN ANY WAY CONNECTED WITH THE USE OR PERFORMANCE OF PORTAL; (B) ANY DELAY OR INABILITY TO USE THE PORTAL OR SERVICES; (C) THE PROVISION OF OR FAILURE TO PROVIDE SERVICES, OR FOR ANY INFORMATION OR SERVICES OBTAINED THROUGH THE PORTAL; (D) OR OTHERWISE ARISING OUT OF THE USE OF THE PORTAL OR THE SERVICES OF THE COMPANY; WHETHER OR NOT ALL OF THE ABOVE LOSSES, CLAIMS OR DAMAGES ARE BASED ON CONTRACT, TORT, NEGLIGENCE, STRICT LIABILITY, EVEN IF THE COMPANY AND/OR ITS AFFILIATES AND/OR ITS ASSOCIATES HAVE BEEN ADVISED OF THE POSSIBILITY OF SUCH LOSSES, CLAIMS OR DAMAGES.'
        }
      ]
    },
    {
      title: 'TERMINATION (TEMPORARY AND PERMANENT DISABLEMENT)',
      content: [
        {
          text: 'Unless otherwise provided in these Terms, the Services offered to you may be terminated by the Company without assigning any reasons at any time at the sole discretion of the Company. Upon termination / suspension, you shall not have the right to use or access the Portal/Services.'
        },
        {
          text: 'The company reserves the right to suspend and/ or terminate your access to the Services in case of any non-adherence to these Terms and Conditions by you.'
        }
      ]
    },
    {
      title: 'GOVERNING LAW AND DISPUTE RESOLUTION',
      content: [
        {
          text: 'These terms and conditions are governed and construed in accordance with the laws of India. The courts in Mumbai shall have exclusive jurisdiction to hear disputes arising out of these terms.'
        }
      ]
    },
    {
      title: 'FORCE MAJEURE',
      content: [
        {
          text: 'The Company shall be under no liability whatsoever in the event of non-availability of any portion of the Portal or subscribed content occasioned by act of God, war, disease, revolution, riot, civil commotion, strike, lockout, flood, fire, failure of any public utility, manmade disaster, infrastructure failure or any other cause whatsoever beyond the control of the Company.'
        }
      ]
    },
    {
      title: 'SEVERABILITY',
      content: [
        {
          text: 'If any of the provisions of these Terms are deemed invalid, void, or for any reason unenforceable, that part of these Terms will be deemed severable and will not affect the validity and enforceability of any remaining provisions of these terms.'
        }
      ]
    },
    {
      title: 'CONTACT DETAILS',
      content: [
        {
          text: 'Mrs. Radha Nair, Reliance Corporate IT Park, TC-22, Thane Belapur Road, Ghansoli, Navi Mumbai 400701',
          email: 'grievance.officer@jio.com'
        }
      ]
    }
  ]
};

const TermsAndConditions = ({ setShowTermsAndConditions }) => {
  const handleClose = (e) => {
    e.stopPropagation();
    setShowTermsAndConditions(false);
  };

  const handleContainerClick = (e) => {
    if (e.target === e.currentTarget) {
      e.stopPropagation();
      setShowTermsAndConditions(false);
    }
  };

  return (
    <div className="tnc-modal-container" onClick={handleContainerClick}>
      <div className="tnc-modal">
        <div className="modal-dialog modal-lg">
          <div className="modal-content-tnc p-0">
            <div className="modal-header1 d-flex justify-content-md-start justify-content-center">
              <h1 className="modal-title fs-5">{termsData.title}</h1>
              <button
                type="button"
                aria-label="Close"
                className="btn-close position-absolute end-0 me-4"
                onClick={handleClose}
              >
                <img src={btn} alt="close" />
              </button>
            </div>
            <div className="modal-body p-3">
              {termsData.sections.map((section, sIdx) => (
                <div key={sIdx} className="tnc-section">
                  <h6>
                    {sIdx + 1}. {section.title}
                  </h6>
                  {section.content.map((item, cIdx) => (
                    <React.Fragment key={cIdx}>
                      <p>
                        <strong>
                          {sIdx + 1}.{cIdx + 1}
                        </strong>
                        <span>
                          {item.text}
                          {item.email && (
                            <>
                              {' '}
                              <a href={`mailto:${item.email}`}>{item.email}</a>
                            </>
                          )}
                        </span>
                      </p>
                      {item.sublist && (
                        <ul className="tnc-sublist">
                          {item.sublist.map((sub, subIdx) => (
                            <li key={subIdx}>{sub}</li>
                          ))}
                        </ul>
                      )}
                    </React.Fragment>
                  ))}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsAndConditions;
